var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 5a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2v1.128a3 3 0 0 1-.959 2.198L15 13.936v4.281a2 2 0 0 1-.956 1.706l-1.632.999c-1.332.815-3.044-.144-3.044-1.706v-5.308l-5.51-5.625A3 3 0 0 1 3 6.183V5Zm17 0H5v1.184a1 1 0 0 0 .286.7l5.511 5.625a2 2 0 0 1 .571 1.4v5.307L13 18.217v-4.28a2 2 0 0 1 .64-1.466l6.04-5.61a1 1 0 0 0 .32-.733V5Z",
  fill: "currentColor"
})));
export default SvgFilter;